<template>
  <div class="progress-bar">
    <div class="progress-bar-bar">
      <div
        class="progress-bar-bar-current"
        :class="barType"
        :style="{ width: Math.round(100 * progressBarRatio )+ '%' }"
      />
    </div>
    <div class="progress-bar-count">
      <div v-if="barType == 'holidays'">
        <span
          v-if="total >= 0 && total !== null"
          class="progress-bar-count-current"
        >
          {{ total-current >= 0 ? $tc('daysLeftThisYear',total-current) : $tc('daysOverTheHolidaysLimit',current-total) }}
        </span>
      </div>
      <!-- <div v-if="barType == 'default' || barType == 'total'">
        {{ $t('thisWeek') }}
      </div> -->
    </div>
  </div>
</template>
<script>

export default {
  props: {
    current: Number,
    total: Number,
    barType: {
      default: 'default', // it can be 'default', 'total' or 'holidays'
      type: String,
    },
  },
  computed:{
    progressBarRatio(){
      if(isNaN(this.total) || this.total == 0)
        if(this.current === 0 || isNaN(this.current)) return 0
        else return 1
      return Math.min(1, this.current / this.total)
    },

  },
}
</script>

<style lang="scss" scoped>
.progress-bar {
  &-bar {
    height: 4px;
    background-color: $athens-gray;
    &-current {
      height: 100%;
      background-color: $blue;
      &.holidays {
        background-color: $day-off;
      }
      &.total {
        background-color: $turquoise;
      }
    }
  }
  &-count {
    font-size: 14px;
    margin-top: 9px;
    color: $bluebell;
    &-total {
      font-weight: bold;
    }
  }
}
</style>
